import { claimOrderReference } from "./apiProxy";

const { EncryptStorage } = require("encrypt-storage");

const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

const ORDER_REFERENCE_KEY = "orefwithoutprefix";
const ORDER_REFERENCE_ALIAS_KEY = "orderreference_wtpre";

function persistOrderReference(orderReferenceWtpre) {
  if (!orderReferenceWtpre) {
    return "";
  }

  encryptStorage.setItem(ORDER_REFERENCE_KEY, orderReferenceWtpre);
  encryptStorage.setItem(ORDER_REFERENCE_ALIAS_KEY, orderReferenceWtpre);
  return orderReferenceWtpre;
}

export function getStoredOrderReference() {
  return (
    encryptStorage.getItem(ORDER_REFERENCE_KEY) ||
    encryptStorage.getItem(ORDER_REFERENCE_ALIAS_KEY) ||
    ""
  );
}

export function clearStoredOrderReference() {
  encryptStorage.removeItem(ORDER_REFERENCE_KEY);
  encryptStorage.removeItem(ORDER_REFERENCE_ALIAS_KEY);
}

export async function getOrClaimOrderReference({
  brand_id,
  forceRefresh = false,
} = {}) {
  const existingOrderReference = forceRefresh ? "" : getStoredOrderReference();
  if (existingOrderReference) {
    return persistOrderReference(existingOrderReference);
  }

  if (!brand_id) {
    throw new Error("brand_id is required");
  }

  const response = await claimOrderReference({
    brand_id,
  });

  return persistOrderReference(response?.orderreference_wtpre || "");
}

export async function ensureOrderReference(brand_id) {
  return getOrClaimOrderReference({ brand_id });
}

export function setStoredOrderReference(orderReferenceWtpre) {
  return persistOrderReference(orderReferenceWtpre);
}
